import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import DashboardComponent from '../components/DashboardComponent';
import HeaderComponent from '../components/HeaderComponent';

class DashboardPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <DashboardComponent />
            </div>
        );
    }
}

export default DashboardPage;